module.exports = __webpack_public_path__ + "static/media/passage-frame.174b59e7.png";